// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__rXt3k","checkboxCol":"Table_checkboxCol__2OYus","emailCol":"Table_emailCol__3AmTK","actionCol":"Table_actionCol__qY6OZ"};